import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Score from './Score';

export default
class LeaderboardScoreTricks extends Component {
    static propTypes = {
        scoreStyle: PropTypes.object.isRequired,
        athlete: PropTypes.object.isRequired,
        colors: PropTypes.object.isRequired,
        values: PropTypes.oneOfType([
            item => item === undefined,
            PropTypes.array.isRequired
        ]),
        roundConfig: PropTypes.object.isRequired
    }

    render() {
        const {
            scoreStyle,
            athlete,
            colors,
            values,
            roundConfig: {
                mostTricksCount
            }
        } = this.props;
        if( !mostTricksCount ){
            return null;
        }

        let tricks = []
        if( values ){
            tricks = [ ...values ];
        }
        if (mostTricksCount < tricks.length) {
            tricks.splice(
                mostTricksCount,
                tricks.length - mostTricksCount
            );
        }

        while (tricks.length < mostTricksCount) {
            tricks.push({ dummy: true });
        }

        return (
            <div className="score tricks">
                {tricks
                .map((
                    {
                        rank,
                        highlight,
                        drop
                    },
                    i
                ) => {
                    let style = highlight
                        ? colors.highlight
                        : colors.nonCounting;

                    if (athlete.isLive) {
                        style = highlight
                            ? colors.highlightActive
                            : colors.nonCounting;
                    }

                    if (drop) {
                        style = colors.drop;
                    }

                    return (
                        <Score
                            key={`leaderboard_trick_${athlete.externalId}_${i}`}
                            style={{
                                ...style,
                                ...scoreStyle
                            }}
                        >
                            {rank}
                        </Score>
                    );
                })}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/table/TableLeaderboard/scored/scores/Tricks.js